"use client";

import type { UniqueIdentifier } from "@dnd-kit/core";

const STUDIO_SITUATION_DROP_ID_PREFIX = "situation";
const STUDIO_SITUATION_DROP_ID_SEPARATOR = ":";

export function getStudioSituationDropId(situationId: string) {
  return `${STUDIO_SITUATION_DROP_ID_PREFIX}${STUDIO_SITUATION_DROP_ID_SEPARATOR}${situationId}`;
}

export function isStudioSituationDropId(
  id: UniqueIdentifier | null | undefined,
) {
  return String(id ?? "").startsWith(
    `${STUDIO_SITUATION_DROP_ID_PREFIX}${STUDIO_SITUATION_DROP_ID_SEPARATOR}`,
  );
}

export function getSituationIdFromStudioDropId(
  id: UniqueIdentifier | null | undefined,
) {
  const value = String(id ?? "");

  if (!isStudioSituationDropId(value)) {
    return null;
  }

  return value.slice(
    STUDIO_SITUATION_DROP_ID_PREFIX.length +
      STUDIO_SITUATION_DROP_ID_SEPARATOR.length,
  );
}
